module.exports = __webpack_public_path__ + "footer-logo-pl.png?b2c97cbdf08d967ac4ff4660ec5d68dc";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/footer-logo-pl.png
// module id = 941
// module chunks = 0